import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Tooltip from '../../components/Tooltip';
import { searchImage, clearImage } from '../../actions/SearchFieldActions';
import {
  searchParameterSelector
} from '../../selectors/SearchParameter.Selectors';
import './Image.sass';
import { clearModelInstance } from '../../actions/EvaluationActions';

class Image extends Component {
  constructor(props) {
    super(props);
    this.handleShowImageEvaluationInfo = this.handleShowImageEvaluationInfo.bind(this);
    // this.handleImageClick = this.handleImageClick.bind(this);
    this.handleImageMouseOver = this.handleImageMouseOver.bind(this);
    this.handleImageMouseOut = this.handleImageMouseOut.bind(this);
  }

  async handleShowImageEvaluationInfo(event) {
    event.stopPropagation();
    const {
      history,
      query,
      sn: imageSN,
      dispatch
    } = this.props;
    await dispatch(clearImage());
    await dispatch(clearModelInstance());
    history.push(`${history.location.pathname}/${imageSN}/segmentation?${query}`);
    await dispatch(searchImage(imageSN));
  }

  // handleImageClick(event) {
  //   event.preventDefault();
  //   const { sn, isSelected, dispatch } = this.props;
  //   if (isSelected) {
  //     dispatch(deselectImage(sn));
  //   } else {
  //     dispatch(selectImage(sn));
  //   }
  // }

  handleImageMouseOver() {
    console.log(`mouseover ${this}`);
  }

  handleImageMouseOut() {
    console.log(`mouseout ${this}`);
  }

  render() {
    const {
      url,
      width,
      height,
      isSelected
    } = this.props;
    return (
      <div
        className={`grid-img-wrapper ${isSelected ? 'selected' : ''}`}
        // onClick={this.handleImageClick}
        // onMouseOver={ this.handleImageMouseOver }
        // onMouseOut={ this.handleImageMouseOut }
      >
        <img className="grid-img" src={url} alt="test-img" />
        <div className="grid-img-info" onClick={e => e.stopPropagation()}>
          Width: {width}px <br />
          Height: {height}px

          <Tooltip
            className="grid-tooltip-info"
            content="Evaluation"
            position="top"
            onClick={this.handleShowImageEvaluationInfo}
          >
            <span className="fa fa-info-circle" />
          </Tooltip>
        </div>
      </div>
    );
  }
}

Image.propTypes = {
  sn: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  query: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired
};

function mapStateToProps(store, props) {
  const { SearchField } = store;

  return {
    query: queryString.stringify(searchParameterSelector(store)),
    isSelected: SearchField.selectedImages.has(props.id)
  };
}

export default withRouter(connect(mapStateToProps)(Image));



// WEBPACK FOOTER //
// ./src/containers/Main/Image.jsx